<div [hidden]="consulta">
<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- título -->
            <header>
                <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
            </header>
       
            <div class="divisor32"></div>
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Ciclo'" [disabled]="true" [(ngModel)]="entidad.ciclo" [errorActivo]="errorActivo" ></inputCustom>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Descripción'" [disabled]="true" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Departamento'" [disabled]="true" [(ngModel)]="entidadpuesto.departamento" [errorActivo]="errorActivo" ></inputCustom>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Puesto'" [disabled]="true" [(ngModel)]="entidadpuesto.nombre" [errorActivo]="errorActivo" ></inputCustom>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <datePickerV2Custom [titulo]="'Ultima Edición'" [disabled]="true"
                    [(ngModel)]="entidadpuesto.fechaedicion"
                    ></datePickerV2Custom>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Editó'" [disabled]="true" [(ngModel)]="entidadpuesto.usuario" [errorActivo]="errorActivo" ></inputCustom>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="">
                        <button matTooltip="Previsualizar" class="boton botonSM filledBlanco"
                        (click)="Previsualizar()">
                        <span> {{'Previsualizar'}}</span>
                    </button>
                    </div>
                </div>
            </div>
            <mat-tab-group #tab preserveContent mat-stretch-tabs>
                <mat-tab label="Preguntas opcionales">
                    <preparacionpregunta_opcional #general
                        [id]="idperiodoevaluacion"
                        [iddepartamento]="iddepartamento"
                        [idpuesto]="idpuesto"
                        [entidadpuesto]="entidadpuesto"
                        (actualizar)="SetPuesto()">
                    </preparacionpregunta_opcional>
                </mat-tab>
                <mat-tab label="Preguntas obligatorias/institucionales"> 
                    <preparacionpregunta_obligatorio
                        [id]="idperiodoevaluacion"
                        [iddepartamento]="iddepartamento"
                        [idpuesto]="idpuesto">
                    </preparacionpregunta_obligatorio>
                </mat-tab>
            </mat-tab-group>

            <div class="divisor20"></div>
            <div class="row margen">
                <div class="col-12">
                    <div class="panelBotonesFiltro">
                        <button class="boton botonSM filledBlanco" (click)="Salir()">
                            <span> {{'Cancelar'}}</span>
                        </button>
                        <div class="divisorH16 "></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            <span> {{'Guardar'}}</span>
                        </button>
                    </div>
                </div>
            </div>

        </section>
    </div>
    <div class="col-lg-12" style="padding: 0px">

    </div>
</div>
</div>
<div #containerEvaluacion></div>